// extracted by mini-css-extract-plugin
module.exports = {"THEME_NAME":"\"fixtercore\"","back-link":"BackToLink_back-link___E6fK"};